<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RZPP0X/tc-custom/9780374719470.jpg?1731182959724" alt="This image is the cover for the book What We Did"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">What We Did
      </h1>
      <p class="bookDescription body article font2">
        <p><b>He stole her childhood . . . she’ll take his future</b><i><br/><br/>Something happened, she didn’t know what, something spun, the world turning, back, back, too fast. She would be sick. Bridget put out a hand to steady herself against the wall.</i><br/><br/>Bridget has a secret—one she keeps from everyone, even her husband. One that threatens to explode when her childhood music teacher, Carmichael, walks into her dress shop. With him is a young girl on the cusp of adulthood, fresh-faced and pretty. She reminds Bridget of herself at that age, naïve and vulnerable. <br/><br/>Bridget wants him away—away from her, away from that girl. But Carmichael won’t leave her alone, won’t stop stalking her. And Bridget’s not a little girl anymore. When he pushes her too far, she snaps. But what she thought was a decisive act only unravels more insidious threats—more than she could have ever imagined—and from which no one is safe, not even her family. <br/><br/>The bestselling British author Christobel Kent has written yet another thrilling page-turner with a twisted, riveting conclusion. <i>What We Did</i> is a nightmarish, impossible-to-put-down tale of the secrets we keep from our families, of chilling childhood abuse, and of long-awaited retribution.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christobel Kent
      </h2>
      
      <p class="authorDescription body article">Christobel Kent&rsquo;s previous books include <i>A Time of Mourning, A Party in San Niccolo, Late Season</i>, and <i>A Florentine Revenge</i>. She lives near Cambridge, England, with her husband. <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4e884511